__turbopack_context__.v({
  "breadcrumbs": "breadcrumbs-module-scss-module__HghSJG__breadcrumbs",
  "iconWrapper": "breadcrumbs-module-scss-module__HghSJG__iconWrapper",
  "lastItem": "breadcrumbs-module-scss-module__HghSJG__lastItem",
  "link": "breadcrumbs-module-scss-module__HghSJG__link",
  "linkWrapper": "breadcrumbs-module-scss-module__HghSJG__linkWrapper",
  "svg": "breadcrumbs-module-scss-module__HghSJG__svg",
  "truncatedSegment": "breadcrumbs-module-scss-module__HghSJG__truncatedSegment",
});
